/**
 * @generated SignedSource<<111279d0d0d7751c136a072c5d2ed8d6>>
 * @relayHash b8397d49737a9b63f84bf3c7e6b94a86
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 45fc378cafe9a536c42f9411e782681c84a1e7bea7298f93a9b154885bbe7bd8

import type { ConcreteRequest } from 'relay-runtime';
export type viewAgent_activationQuery$variables = {
  cloudId: string;
  product: string;
};
export type viewAgent_activationQuery$data = {
  readonly tenantContexts: ReadonlyArray<{
    readonly activationIdByProduct: {
      readonly active: string | null;
    } | null;
  } | null> | null;
};
export type viewAgent_activationQuery = {
  response: viewAgent_activationQuery$data;
  variables: viewAgent_activationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "product"
  }
],
v1 = [
  {
    "args": [
      {
        "items": [
          {
            "kind": "Variable",
            "name": "cloudIds.0",
            "variableName": "cloudId"
          }
        ],
        "kind": "ListValue",
        "name": "cloudIds"
      }
    ],
    "concreteType": "TenantContext",
    "kind": "LinkedField",
    "name": "tenantContexts",
    "plural": true,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "product",
            "variableName": "product"
          }
        ],
        "concreteType": "TenantContextActivationId",
        "kind": "LinkedField",
        "name": "activationIdByProduct",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "active"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "viewAgent_activationQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "viewAgent_activationQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "45fc378cafe9a536c42f9411e782681c84a1e7bea7298f93a9b154885bbe7bd8",
    "metadata": {},
    "name": "viewAgent_activationQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "013186f81744209f235f217a8db7ae2d";

export default node;
